export enum MeasurementTypeCategoryEnum {
  BODY_COMPOSITION = 'BODY_COMPOSITION',
  ANALYTICS = 'ANALYTICS',
  ANTHROPOMETRIC = 'ANTHROPOMETRIC',
  INTERNAL = 'INTERNAL'
}
